export default {
  errorsContainer: {
    color: 'red',
    paddingTop: '10px',
  },
  box: {
    border: '1px solid rgba(0, 0, 0, 0.125)',
    padding: '35px',
    marginBottom: '10px',
    marginTop: '10px',
    borderRadius: '4px',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
  },
};



// WEBPACK FOOTER //
// ./src/common/DynamicFormList/style.js